<template>
  <div class="dashboard-container">
    <div v-if="fullName" class="dashboard-text">
      Имя пользователя: {{ fullName }}
    </div>
    <div v-if="username" class="dashboard-text">@username: {{ username }}</div>
    <div class="dashboard-text">
      Роли:
      <span v-for="(role, index) in roles" :key="role"
        >{{ enumFilter("role_type", role)
        }}<template v-if="index < roles.length - 1">, </template></span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { enumFilter } from "@/utils/filters";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["name", "roles", "username", "fullName"]),
  },
  methods: {
    enumFilter,
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
